<template>
  <div v-if="$store.state.tmpPlannedTracks.length">
    <AppTrackGroup  :trackGroup="plannedGroup" :searchText="''" :showDetails="false">
      <button v-if="window.isDesktop" class="btn btn-primary btn-sm" @click="newPlannedTrack">{{ $t('newPlannedTrack') }}</button>
    </AppTrackGroup>
    <br>
  </div>
</template>

<script lang="ts">
import BaseComponent from './Base.vue';
import TrackGroup from '@/ts/TrackGroup';
import GpsTrack from '@/ts/GpsTrack';
import { TrackStatus, TrackType } from '@/ts/types';
import Track from '@/ts/Track';
import { EventBus } from '@/ts/EventBus';
import { defineComponent } from "vue";

export default defineComponent({
    extends: BaseComponent,
    data() {
        const plannedGroup: TrackGroup = new TrackGroup();

        return {
            plannedGroup
        };
    },
    mounted() {
        this.plannedGroup.label = 'tmpPlannedTracks';
        this.plannedGroup.translate = 'tmpPlannedTracks';
        this.plannedGroup.tracks = [];
        EventBus.$on('newPlannedTrack', this.newPlannedTrack);
    },
    methods: {
        newPlannedTrack() {
            const newGpstrack: GpsTrack = new GpsTrack(Date.now(), 'Nowa trasa', '', '[]', '#FF0000', 0, 0, TrackStatus.planned, TrackType.bicycle, null, null, '', undefined, 1);
            const track = new Track(newGpstrack, true, false);
            this.$store.commit('addPlannedTrack', track);
            this.plannedGroup.tracks.push(track);
            this.$store.commit('setEditedTrack', track);
            this.$store.state.editedTrack.createMapObjects(window.mainmap);
        },
        onStoreTracksChanged(value: string, oldValue: string) {
            this.plannedGroup.tracks = [];
            for (const plannedTrack of this.$store.state.tmpPlannedTracks) {
              this.plannedGroup.tracks.push(plannedTrack);
            }
        }
    },
    watch: {
        "$store.state.tmpPlannedTracks": [{
            handler: "onStoreTracksChanged"
        }]
    }
})


</script>